import { useUserContext } from '@context/UserContext';
import { getHistoryUser, zafClient } from '@services/Zendesk';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { HistoryItem } from 'types/UserZendesk';

export function useHistoryUser() {
  const { selectedUser } = useUserContext();
  const [loading, setLoading] = useState(true);
  const [history, setHistory] = useState<HistoryItem[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const response = await getHistoryUser(zafClient, selectedUser?.id || 0);
        setHistory(response || []);
      } catch (error) {
        console.error('Error fetching history user:', error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);
  return {
    loading,
    history,
    navigate,
  };
}
